<template>
  <div class="col-xl-6 mb-3 mb-xl-0" v-loading="loading">
    <div class="col-xl-12 col-lg-6">
      <card header-classes="bg-transparent">
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Atendimento por Tipo de Pagamento
            </h6>
          </div>
        </div>
        <div class="card card-stats mb-4 mb-xl-0" show-footer-line="true">
          <pie-chart :height="250" ref="bigChart" :chart-data="bigBarChart.chartData"
            :extra-options="bigBarChart.extraOptions"></pie-chart>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import PieChart from "@/components/Charts/PieChart";
import { PdvDashboardService } from "@/services/pdv/pdv.dashboard.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PdvUserPaymentDashboard",
  props: ["customer", "startedAt", "finishedAt"],
  data() {
    return {
      loading: false,
      bigBarChart: {
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    PieChart,
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      PdvDashboardService.payment(
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.customer,
      )
        .then((response) => {
          let barData = {
            datasets: response.values,
            labels: response.labels,
          };
          this.bigBarChart.chartData = barData;
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => vm.loading = false);
    },
  },
};
</script>
